<template>
  <div class="py-6">
    <div class="container">
      <div class="row">
        <div class="col-xxl-5 col-xl-6 col-md-8 mx-auto">
          <div class="bg-white rounded shadow-sm p-4 text-left">
            <van-form @submit="commit">
              <van-field
                  v-if="'1' === paramMapAll['EMAIL_OPEN']"
                  v-model="forgetForm.phone"
                  :placeholder="$t('邮箱')"
                  :rules="[{ required: true, message: $t(`请输入`)+$t(`邮箱`) }]"
              />
              <van-field
                v-else
                v-model="forgetForm.phone"
                :placeholder="$t('手机号码')+ (paramMapAll['SMS_PHONE_PREFIX']?`(${paramMapAll['SMS_PHONE_PREFIX']})`:'')"
                :rules="[
                  {
                    required: true,
                    message: $t(`请输入手机号码`)
                  },
                  {
                    pattern: /^\d{5,}$/,
                    message: $t('手机号码格式错误'),
                    trigger: 'blur'
                  }
                ]"
                type="tel"
              />
              <van-field
                v-model="forgetForm.smsCode"
                :name="$t('验证码')"
                :placeholder="$t('验证码')"
                :rules="[
                  {
                    required: true,
                    message: $t('请输入验证码')
                  }
                ]"
                class="d-flex"
                type="number"
              >
                <template #button>
                  <van-count-down
                    v-if="time > 0"
                    :time="time"
                    @change="changeTime"
                  >
                    <template #default="timeData">
                      <span class="block text-grey">{{
                        $t("在_s后发送", [timeData.seconds])
                      }}</span>
                    </template>
                  </van-count-down>
                  <van-button
                    v-else
                    size="mini"
                    type="primary"
                    @click.stop="sendCode"
                    >{{ $t("发送验证码") }}
                  </van-button>
                </template>
              </van-field>
              <!--        </div>-->
              <van-field
                v-model="forgetForm.password"
                :name="$t('密码')"
                :placeholder="$t('密码')"
                :rules="[
                  {
                    required: true,
                    message: $t(`请输入密码`)
                  },
                  {
                    pattern: /^.{6,16}$/,
                    message: $t('密码长度为6_16个字符'),
                    trigger: 'blur'
                  }
                ]"
                type="password"
              />
              <van-field
                v-model="forgetForm.rePassword"
                :name="$t('确认密码')"
                :placeholder="$t('确认密码')"
                :rules="[
                  {
                    required: true,
                    message: $t(`请输入确认密码`)
                  },
                  {
                    pattern: /^.{6,16}$/,
                    message: $t('密码长度为6_16个字符'),
                    trigger: 'blur'
                  }
                ]"
                type="password"
              />

              <div style="margin: 16px;">
                <van-button
                  :loading="loading"
                  :loading-text="$t('submitting')"
                  block
                  native-type="submit"
                  small
                  type="primary"
                >
                  {{ $t("submit") }}
                </van-button>
                <van-button
                  block
                  plain
                  small
                  style="margin-top:10px;"
                  to="/login"
                  type="primary"
                >
                  {{ $t("登录") }}
                </van-button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendCode } from "@/api/sys/common";

export default {
  computed: {
    ...Vuex.mapGetters(["paramMapAll"])
  },
  data() {
    return {
      loading: false,
      forgetForm: {},
      time: 0
    };
  },
  created() {
    this.time = parseInt(Cookies.get("Forget_Code_Countdown_Time"));
  },
  methods: {
    sendCode() {
      if (!this.forgetForm.phone) {
        this.$dialog.alert({ message: this.$t("请输入手机号码") });
        return;
      }
      this.time = 60000;
      Cookies.set("Forget_Code_Countdown_Time", 60000);
      sendCode({
        phone: this.forgetForm.phone,
        sendType: "FORGET_PWD_CODE",
        isEmail: '1' === this.paramMapAll['EMAIL_OPEN'],
      })
        .then(() => {
          this.$dialog.alert({
            message: this.$t("验证码发送成功")
          });
        })
        .catch(() => {
          this.time = 0;
          Cookies.set("Forget_Code_Countdown_Time", 0);
        });
    },
    changeTime(timeData) {
      this.time = timeData.seconds * 1000 + timeData.milliseconds;
      Cookies.set(
        "Forget_Code_Countdown_Time",
        timeData.seconds * 1000 + timeData.milliseconds
      );
    },
    commit() {
      if (this.forgetForm.rePassword !== this.forgetForm.password) {
        this.$toast.fail(this.$t("确认密码不一致"));
        return;
      }
      this.loading = true;
      let form = Object.assign({}, this.forgetForm);
      this.$store
        .dispatch("user/forgetPwd", form)
        .then(() => {
          this.loading = false;
          this.$toast.success(this.$t("Commit_Success"));
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
